<template>
  <div class="content">
    <div class="md-layout">
      <div class="md-layout-item md-medium-size-100 md-size-100">
        <DetalleShow data-background-color="green"> </DetalleShow>
      </div>
    </div>
  </div>
</template>

<script>
import DetalleShow from "../components/Pedido/DetalleShow.vue";

export default {
  components: {
    DetalleShow
  },
  mounted() {}
};
</script>
